import { render } from "./KutaTable.vue?vue&type=template&id=517bc7f8&ts=true"
import script from "./KutaTable.vue?vue&type=script&lang=ts"
export * from "./KutaTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kutas.findingyou.co/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__